import React from 'react';
import { useSelector } from 'react-redux';
import * as actions from '../../store/actions/index';
import Aux from '../../hoc/Aux';
import DocumentationFileTableList from './DocumentationFileTableList';
import { useParams } from "react-router";
import { URLS } from '../../urls';
import { ROUTES } from '../../routes';
import {Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Documentation = (props) => {

  const { t } = useTranslation();

  let productSystem = {};

  let { productSystemId } = useParams();

  const loading = useSelector(state => state.inventory.loadingProductSystem );

  const thisProductSystem = useSelector(state => {
    return (productSystemId) => actions.getProductSystem(state, productSystemId)
  });

  const getImageUrl = (productSystem) => {
    let imageArray = productSystem.product_system_images.filter(function(element){ return element.usage === 'documentation' });
    let firstImage = (imageArray !== [])? imageArray[0] : undefined
    let image_url = (firstImage !== undefined)? firstImage.image_url : ""
    return image_url;
  }

  if ( !loading || productSystem !== {}) {
    productSystem = thisProductSystem(productSystemId) || {};

    return (
    <Aux>
      <div className="main-container">
         <div className="container">
            <div className="row justify-content-center">
               <div className="col-lg-12 col-xl-12">
                  <div className="page-header">
                     <h1>{ t('documentations.headline') }</h1>
                     <p className="lead"></p>
                  </div>
                  <div className="row mt-3">
                    <div className="col-lg-11 col-xl-3 mb-10">
                      <div className="card" style={{backgroundColor: "white"}}>
                        <img alt={productSystem.title} className="card-img-top d-none d-xl-block" src={URLS['BACKEND'] + '/' + getImageUrl(productSystem)} />

                        <div className="card-body">
                          <h5 className="card-title">{productSystem.title}</h5>
                                              <Link to={ROUTES.TO_DOCUMENTATIONS}>
                            <button type="button" style={{marginRight: "0px", color: "white"}} className="btn btn-primary btn-project">{ t('documentation.button.back') }</button>
                          </Link>
                        </div>
                      </div>
            				</div>

            				<div className="col-lg-11 col-xl-8 mb-10">
                      <div className="card" style={{backgroundColor: "white"}}>
                        <div className="card-body">
                          <DocumentationFileTableList productSystemId={productSystemId} />
                        </div>
                      </div>
                    </div>
                 </div>
            </div>
          </div>
        </div>
      </div>
    </Aux>
  )
} else {
 return null;
}

}


export default Documentation;



// WEBPACK FOOTER //
// ./src/components/Documentations/Documentation.js